import template from './template.html'
import controller from './kicker.controller'

export default {
  restrict: 'E',
  template,
  bindings: { story: '=storyObj' },
  controller,
  controllerAs: 'vm',
}
